import React, { useEffect, useRef } from 'react';
import { Scrollbars } from 'rc-scrollbars';
import prevDataIcon from '../../../images/prevData.png';
import nextDataIcon from '../../../images/nextData.png';
import nextDataDisabledIcon from '../../../images/nextData_disabled.png'
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { API_URL } from '../../../config/constants';
import moment from 'moment';
import { idKey, isFullListSelected } from './selectionUtils';

function DataListMenu({ dDs, monitData, selSensorIdx, selDataIdx, setSelDataIdx, getPrevData, getMoreData, isLastData, chkedData, setChkedData, onRowClick}) {
    const scrollbarRef = useRef();
    monitData?.sort(function compare(a, b) {
        if (a.date > b.date) return -1;
        if (a.date < b.date) return 1;
        return 0;
    });

    const companyInitial = 'K';
    const sensorTypeInitial = 'D';
    // 추후 계정 정보에서 company 컬럼 데이터 받아오도록 수정要
    // company 정보를 기준으로 rawData 테이블을 선별해 받아옴
    const company = "세동산업";

    const onCheckAll = (e) => {
        e.preventDefault();
        const allIdNos = (monitData ?? []).map((el) => el.dataId);
        if (isFullListSelected(monitData, chkedData)) {
            setChkedData([]);
        } else {
            setChkedData([...allIdNos]);
        }
    }

    const handleDownloadRawBundle = (e) => {
        e.preventDefault();
        makeRawBundle()
    }

    function makeCsvData(selData) {
        console.log(selData)
        const grpNamesStr = dDs.indexName;
        const labelArr = ["time", ...grpNamesStr];
        const dataArr = selData.split(';');
        dataArr.pop();
        const arrayConvertedDataArr = dataArr.map(el => el.split(','));
        const mergedArr = [labelArr, ...arrayConvertedDataArr];
        return mergedArr;
    }


    async function makeRawBundle() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getRawBundle`, {
            isAbout: dDs["tableName"],
            dataIds: chkedData,
        });

        const { success, datum } = response.data;
        if (!success) {
            window.alert('파일 저장에 실패하였습니다. 잠시 후 다시 시도해주세요.')
            return;
        }

        const zip = new JSZip();

        function csvEscape(v) {
            if (v == null) return '';
            const s = String(v);
            if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
            return s;
        }

        function toCsvText(rows) {
            return rows.map(row => row.map(csvEscape).join(',')).join('\n');
        }


        datum.forEach((item) => {
            const filename = `${companyInitial}${sensorTypeInitial}${item["date"]}.csv`;
            console.log(item)
            // ✅ makeCSVData는 배열(rows)을 리턴
            const rows = makeCsvData(item["data"]);
            const csvText = '\uFEFF' + toCsvText(rows); // BOM 포함(엑셀 한글 깨짐 방지)
            zip.file(filename, csvText);
        });

        const zipBlob = await zip.generateAsync({ type: "blob" });
        const zipName = `${companyInitial}${sensorTypeInitial}_${moment().format("YYMMDD_HHmmss")}.zip`;
        saveAs(zipBlob, zipName);
    }


    useEffect(() => {
        scrollbarRef.current?.scrollToTop();
    }, [selSensorIdx]);

    const selectedKeySet = new Set(chkedData.map(idKey));

    return (

        <div className='dataTitleListArea'>
            <div className='dlBtnsArea'>
                {/* 상단 버튼 제거(숨김) */}
                
            </div>
            {
                monitData?.length > 0 &&
                <React.Fragment>
                    <div className='selectDataTitle'>데이터 선택</div>
                    {/* <div className='dataTitleContainer' id='scrollArea'> */}
                    <button className='getPrevDataBtn' onClick={getPrevData}>
                        <img src={prevDataIcon} alt='이전' />
                    </button>
                    <Scrollbars className='dataTitleContainer' id='scrollArea' style={{ width: '255px', height: 'calc(100% - 38px - 62px)' }} ref={scrollbarRef}>
                        <ul className='dataTitleUl'>
                            {
                                monitData?.map((el, idx, arr) => {
                                    const isSelected = selectedKeySet.has(idKey(el.dataId));
                                    const date = el.date;
                                    return (
                                        <li className='dataTitleLi' key={idx}>
                                            <button
                                                className={isSelected ? 'dataTitleBtn selected' : 'dataTitleBtn'}
                                                onClick={e => {
                                                    e.preventDefault();
                                                    if (!e.shiftKey && !e.ctrlKey && !e.metaKey) {
                                                        setSelDataIdx(idx);
                                                    }
                                                    onRowClick(e, idx, el.dataId);
                                                }}
                                            >
                                                {
                                                    `${date.substr(0, 4)}년 ${parseInt(date.substr(4, 2))}월 ${parseInt(date.substr(6, 2))}일 ${date.substr(9, 2)}:${date.substr(11, 2)}:${date.substr(13, 2)}`
                                                }
                                            </button>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </Scrollbars>
                    {/* </div> */}
                    <button className='getNextDataBtn' onClick={getMoreData} disabled={isLastData} ><img src={isLastData ? nextDataDisabledIcon : nextDataIcon} alt='이후' /></button>
                </React.Fragment>
            }
        </div>
    );
}

export default React.memo(DataListMenu);